module.exports = __webpack_public_path__ + "img/mother-of-thousands-4.3de3c5d6.jpeg";